import { atom } from 'recoil';

export const dataCommerceForm = atom({
  key: 'dataCommerceForm',
  default: undefined,
});
